import { ChevronDownIcon, DeleteIcon } from "@chakra-ui/icons";
import {
  Box,
  Collapse,
  Divider,
  FormControl,
  FormLabel,
  Input,
  Stack,
  useDisclosure,
} from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import ReactSelect from "react-select";
import { selectStyles } from "../../../utils/selectStyel";
import RuleTypeSwitch from "./RulesItemsComp/RuleTypeSwitch";

const RuleItem = ({
  control,
  register,
  path,
  remove,
  schema,
  rule,
  depth = 0,
  isStep = true,
}) => {
  const { isOpen, onToggle } = useDisclosure({
    defaultIsOpen: depth === 0,
  });

  return (
    <Box
      bg="white"
      shadow="md"
      borderRadius="lg"
      p={4}
      mb={4}
      borderLeft="5px solid"
      borderColor={depth === 0 ? "blue.400" : "gray.300"}
      ml={`${depth * 6}px`}
    >
      {/* Header */}
      <Stack direction="row" gap={5} align="center">
        <Box
          as="button"
          width="100%"
          px={4}
          py={3}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          fontWeight="semibold"
          borderRadius="md"
          bg="#F7FAFC"
          _hover={{ bg: "gray.100" }}
          onClick={onToggle}
        >
          <Box textAlign="left">{isStep ? rule?.TYPE ?? "RULE" : "Rule"}</Box>

          <Box
            transform={isOpen ? "rotate(180deg)" : "rotate(0deg)"}
            transition="transform 0.2s ease"
          >
            <ChevronDownIcon />
          </Box>
        </Box>
        <DeleteIcon onClick={remove} color="red" size={12} />
      </Stack>

      <Divider my={2} />

      <Collapse in={isOpen} animateOpacity>
        {/* Meta */}
        <Stack direction={{ base: "column", md: "row" }} spacing={4}>
          <FormControl>
            <FormLabel>Type</FormLabel>
            <Controller
              control={control}
              name={`${path}.TYPE`}
              defaultValue="RULE"
              render={({ field }) => (
                <ReactSelect
                  {...field}
                  value={typeOptions.find((o) => o.value === field.value)}
                  onChange={(opt) => field.onChange(opt.value)}
                  options={typeOptions}
                  styles={selectStyles}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              )}
            />
          </FormControl>

          <FormControl>
            <FormLabel>ID</FormLabel>
            <Controller
              control={control}
              name={`${path}.ID`}
              render={({ field }) => (
                <Input w="100%" bg="white" borderColor="gray.300" {...field} />
              )}
            />
          </FormControl>
        </Stack>
        {/* Body */}
        <RuleTypeSwitch
          control={control}
          register={register}
          path={path}
          rule={rule}
          schema={schema}
          depth={depth}
        />
      </Collapse>
    </Box>
  );
};

export default RuleItem;

const typeOptions = [
  { value: "RULE", label: "RULE" },
  { value: "ITERATION", label: "ITERATION" },
  { value: "ASSIGNMENT", label: "ASSIGNMENT" },
  { value: "REST", label: "REST" },
];
